const NotFound = (props) => {
    return(
        <div>
        <text className="text-4l" >Not Found</text>
        </div>
    )
};

export default NotFound;